// 3rd party libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Local Types
import localStoreTypes from '@webapp/store/types.js';

// Shared Modules
import sharedEpicTypes from '@shared/epics/types.js';

const postalAddressMixin = {
    data() {
        return {
            address: {
                street: '',
                zipCode: '',
                city: '',
                region: '',
                country: null,
            },
        };
    },
    computed: {
        ...mapGetters([
            'userAddress',
            'hasUserAddress',
            'getLatestValidationError',
            'getLatestError',
        ]),

        ...mapGetters('countries', ['countriesList']),

        hasAddressFieldsChanged() {
            const isCountryChanged = this.address.country?.iso2 !== this.userAddress.countryCode;

            return this.address.street !== this.userAddress.street ||
                this.address.zipCode !== this.userAddress.zipCode ||
                this.address.city !== this.userAddress.city ||
                this.address.region !== this.userAddress.region ||
                isCountryChanged;
        },

        isFormValid() {
            return Boolean(this.address.street) && Boolean(this.address.zipCode) && Boolean(this.address.city) && Boolean(this.address.country);
        },

        userAddressToString() {
            return [
                this.userAddress.street,
                this.userAddress.city,
                this.userAddress.region,
                this.countriesList.find((country) => country.iso2 === this.userAddress.countryCode)?.display,
            ]
                .filter((string) => string !== '' && string !== null)
                .join(', ');
        },
    },
    watch: {
        getLatestValidationError: 'onValidationError',
        getLatestError: 'onError',
    },
    async created() {
        await this.getUserAddress();
    },
    methods: {
        ...mapActions({
            getUserAddress: sharedEpicTypes.GET_USER_ADDRESS,
            updateUserAddress: sharedEpicTypes.UPDATE_USER_ADDRESS,
            showAppLoader: localStoreTypes.SET_APP_LOADER,
        }),

        /**
         * On error
         *
         * @param {object} error The error received
         * @returns {void}
         */
        onError(error) {
            const fetchErrors = this.utilGlobalHandleErrorMessages(error);

            this.$notify({
                text: fetchErrors.message,
                type: 'error',
            });

            this.showAppLoader({
                isVisible: false,
            });
        },

        /**
         * Update current address
         *
         * @returns {void}
         */
        async updateAddress() {
            await this.updateUserAddress({
                street: this.address.street,
                city: this.address.city,
                region: this.address.region || null,
                zipCode: this.address.zipCode,
                countryCode: this.address.country.iso2,
            });
        },
    },
};

export default postalAddressMixin;